import React from "react";
import './App.css';
import Layout from "./componects/inc/Layout";
//import NavbarMain from "./componects/inc/NavbarMain";
import NotFound from "./componects/pages/NotFound";
import Home from "./componects/pages/Home";
import ContactUs from "./componects/pages/ContactUs";
import AboutUs from "./componects/pages/AboutUs";
import Products from "./componects/pages/Products";
import Notifications from "./componects/pages/Notifications";
import Education from "./componects/pages/Education";
import FAQ from "./componects/pages/FAQ";
import SupportOnline from "./componects/pages/SupportOnline";
import Login from "./componects/pages/Login";
import RegisterUser from "./componects/pages/RegisterUser";
import UploadImage from "./componects/pages/UploadImage";
import InvoiceForm from './componects/pages/InvoiceForm';

//import Footer from "./componects/inc/Footer";
import { BrowserRouter ,Route,Routes} from "react-router-dom";

function App() {
  return (

    <BrowserRouter>
   
   
      {/* <NavbarMain/>   */}
      
      <Routes>

      <Route element={<Layout />}>
        
      <Route path="/" element={<Home/> }/>

      <Route path="/ContactUs" element={<ContactUs/> }/>

      <Route path="/AboutUs" element={<AboutUs/> }/>

      <Route path="/Products" element={<Products/> }/>

      <Route path="/Notifications" element={<Notifications/> }/>

      <Route path="/Education" element={<Education/> }/>

      <Route path="/FAQ" element={<FAQ/> }/>

      <Route path="/SupportOnline" element={<SupportOnline/> }/>
      
      <Route path="/Login" element={<Login/> }/>

      <Route path="/RegisterUser" element={<RegisterUser/> }/>

      <Route path="/UploadImage" element={<UploadImage/> }/>

      <Route path="/InvoiceForm" element={<InvoiceForm/> }/>

      <Route path="*" element={<NotFound />} /> {/* Catch-all route for 404 */}

      </Route>
      
      </Routes>

      {/* <Footer/> */}
    
    </BrowserRouter>

  );
}

export default App;
